import { __awaiter } from "tslib";
// https://medium.com/swlh/using-firestore-with-typescript-65bd2a602945
export const typeConverter = () => ({
    toFirestore: (data) => data,
    fromFirestore: (doc) => doc.data()
});
// Firebase aborts a transaction outright when a set() lands on an overlapping path while the
// transaction is in flight, and reports it as an error whose message is exactly "set".
const kSetAbortMessage = "set";
const kDefaultRetries = 3;
/**
 * Runs a Firebase transaction, retrying if it is aborted by a concurrent `set()`.
 *
 * Re-running is safe for an update that reads the current value and applies a change to it: the
 * retry sees whatever the `set()` wrote and works from there. Any other failure is thrown straight
 * away rather than retried.
 */
export function retryAbortedTransaction(runTransaction_1) {
    return __awaiter(this, arguments, void 0, function* (runTransaction, retries = kDefaultRetries) {
        for (let attempt = 0;; attempt++) {
            try {
                yield runTransaction();
                return;
            }
            catch (error) {
                const abortedBySet = error instanceof Error && error.message === kSetAbortMessage;
                if (!abortedBySet || attempt >= retries)
                    throw error;
            }
        }
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGItdXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbGl0aWVzL2RiLXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFQSx1RUFBdUU7QUFDdkUsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLEdBQ2tCLEVBQUUsQ0FDakQsQ0FBQztJQUNDLFdBQVcsRUFBRSxDQUFDLElBQU8sRUFBRSxFQUFFLENBQUMsSUFBSTtJQUM5QixhQUFhLEVBQUUsQ0FBQyxHQUE2QyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUMsSUFBSSxFQUFPO0NBQ2xGLENBQUMsQ0FBQztBQUVILDZGQUE2RjtBQUM3Rix1RkFBdUY7QUFDdkYsTUFBTSxnQkFBZ0IsR0FBRyxLQUFLLENBQUM7QUFFL0IsTUFBTSxlQUFlLEdBQUcsQ0FBQyxDQUFDO0FBRTFCOzs7Ozs7R0FNRztBQUNILE1BQU0sVUFBZ0IsdUJBQXVCO3lEQUMzQyxjQUFzQyxFQUFFLE9BQU8sR0FBRyxlQUFlO1FBRWpFLEtBQUssSUFBSSxPQUFPLEdBQUcsQ0FBQyxHQUFJLE9BQU8sRUFBRSxFQUFFLENBQUM7WUFDbEMsSUFBSSxDQUFDO2dCQUNILE1BQU0sY0FBYyxFQUFFLENBQUM7Z0JBQ3ZCLE9BQU87WUFDVCxDQUFDO1lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztnQkFDZixNQUFNLFlBQVksR0FBRyxLQUFLLFlBQVksS0FBSyxJQUFJLEtBQUssQ0FBQyxPQUFPLEtBQUssZ0JBQWdCLENBQUM7Z0JBQ2xGLElBQUksQ0FBQyxZQUFZLElBQUksT0FBTyxJQUFJLE9BQU87b0JBQUUsTUFBTSxLQUFLLENBQUM7WUFDdkQsQ0FBQztRQUNILENBQUM7SUFDSCxDQUFDO0NBQUEifQ==